var _defs, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-40 -40 810 940",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "house",
    fill: "#6FBF45",
    stroke: "#222",
    d: "M4 351q2 -83 33 -150.5t81.5 -109.5t114 -65t130 -23.5t130.5 21.5t114 63t82 108.5t34 150.5q1 106 -42.5 210t-123.5 184.5t-180 112.5q-79 -14 -149.5 -65t-119 -120.5t-76.5 -153t-28 -163.5zM66 346q-12 55 43 122q51 60 112 76q66 17 96 -39q3 -51 -52 -122 q-55 -69 -112 -85q-62 -18 -87 48zM663 353q-18 -74 -82 -52q-55 18 -107 85q-55 72 -48 124q1 8 4 15q29 19 61 19t64 -19.5t57 -46.5t39 -61t12 -64z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#house",
    strokeWidth: 80
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#house"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMars);
export default __webpack_public_path__ + "static/media/mars.63f147f692c28f61832cf354e388b06c.svg";
export { ForwardRef as ReactComponent };